import { useConversion } from "../../../queries/conversions.get.queries";
import { HistoryDetails } from "./details";
import { Loader } from "./loader";

interface ConversionHistoryDetailProps {
  id: string;
}

export default function ConversionHistoryDetail({
  id,
}: ConversionHistoryDetailProps) {
  const { data, isPending, error } = useConversion(id);

  if (isPending) return <Loader />;
  if (error) return <div>Error: {error.message}</div>;

  return data && <HistoryDetails data={data} />;
}
